'use strict';
module.exports = function Task(taskId, poller, licenseRetriever, goldApi, s3Api, s3SignatureValid) {
	if (!taskId || !poller || !licenseRetriever || !goldApi || !s3Api || !s3SignatureValid) {
		throw new Error('invalid-args');
	}
	let currentTaskDownloadUrl;
	const self = this,
		execGoldApi = async (path, params) => {
			const license = await licenseRetriever();
			return goldApi.exec(path, Object.assign({}, params, {
				license: license,
				taskId: taskId
			}));
		},
		getTaskDownloadUrl = async () => {
			if (!currentTaskDownloadUrl || !s3SignatureValid(currentTaskDownloadUrl)) {
				const downloadUrl  = await execGoldApi('task/url');
				currentTaskDownloadUrl = downloadUrl;
			}
			return currentTaskDownloadUrl;
		},
		loadTask = async () => {
			const downloadUrl =  await getTaskDownloadUrl(),
				content = await s3Api.loadUrl(downloadUrl).catch(() => false),
				reducer = (accumulator, currentValue) => Object.assign(accumulator, currentValue);
			if (content && content.length) {
				self.metadata =  content.reduce(reducer, {});
			} else {
				self.metadata = {};
			}
			return self.metadata;
		},
		cancel = () => {
			poller.cancelPolling();
			return execGoldApi('task/cancel');
		},
		waitFor = async stopPredicate => {
			const stopPolling = (taskMetadata) => {
				if (taskMetadata && taskMetadata.status === 'cancelled') {
					return true;
				}
				return stopPredicate(taskMetadata);
			};
			if (poller.isPolling()) {
				throw new Error('invalid-state');
			}
			return poller.poll(loadTask, stopPolling, {pollingInterval: 2000, initialDelay: 1000});
		};

	self.id = () => taskId;

	self.metadata = {};

	self.waitFor = waitFor;
	self.cancelIfWaiting = () => {
		if (poller.isPolling()) {
			return cancel();
		}
	};
	self.cancel = cancel;
	self.exec = execGoldApi;
	self.execAndWaitFor = (path, params, stopPredicate) => {
		return execGoldApi(path, params)
		.then(() => waitFor(stopPredicate));
	};
};
